
import Vue from 'vue';
export default {
    scrollToTop: true,
    head() {
        return {
            title: this.title,
            meta: [{
                hid: 'og:title',
                property: 'og:title',
                content: this.title
            },
            {
                hid: 'twitter:title',
                property: 'twitter:title',
                content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content:'Explore the full details of Ashtavinayak "Shree Siddhivinayak Ganpati Temple Siddhatek" in English.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content:'Explore the full details of Ashtavinayak "Shree Siddhivinayak Ganpati Temple Siddhatek" in English.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content:'Shree Siddhivinayak Temple, Siddhivinayak Ganpati Siddhatek, Ashtavinayak Ganpati Siddhatek, Siddhivinayak Vinayak Temple, Ashtavinayak Yatra Siddhatek, Ganpati Temple Siddhatek Maharashtra, Siddhivinayak Ganesh Temple Pune, Ashtavinayak Pilgrimage Siddhatek, Siddhatek Ganpati Darshan'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content:'Shree Siddhivinayak Temple, Siddhivinayak Ganpati Siddhatek, Ashtavinayak Ganpati Siddhatek, Siddhatek Ganpati Temple, Siddhivinayak Vinayak Temple, Ashtavinayak Yatra Siddhatek, Ganpati Temple Siddhatek Maharashtra, Siddhivinayak Ganesh Temple Pune, Ashtavinayak Pilgrimage Siddhatek, Siddhatek Ganpati Darshan, siddhatek ganpati distance, siddhatek ganpati location, siddhivinayak temple siddhatek timings, siddhatek ganpati distance from pune' 
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/ashtavinayak/siddhivinayak.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/ashtavinayak/siddhivinayak.webp'
          },
        ],
        }
    },

    components: {
    },
    data() {
        return {
            title: 'Shree Siddhivinayak Ganpati Temple Siddhatek | Ashtavinayak - श्री सिद्धिविनायक गणपती सिध्दटेक(अष्टविनायक)',
            langauageMarathi: true
        }
    },
    layout: 'detailsPage-withoutFooter',

    jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/ashtavinayak/siddhivinayak"
        },
        "headline": "Shree Siddhivinayak Ganpati Temple Siddhatek - श्री सिद्धिविनायक गणपती सिध्दटेक(अष्टविनायक)",
        "name" : "Shree Siddhivinayak Ganpati Temple Siddhatek - Ashtavinayak",
        "description": "Explore the full details of Ashtavinayak 'Shree Siddhivinayak Ganpati Temple Siddhatek' in English.",
        "image": this.$config.siteUrl + '/img/ashtavinayak/siddhivinayak.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    },

    computed: {

    },
    methods: {
        changeLanguage: function () {
            this.langauageMarathi = !this.langauageMarathi
        }
    }

}
